export default "__VITE_ASSET__BgUNKOXr__"